'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AppHeader = require('./header/AppHeader');

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _Toolbar = require('./toolbar/Toolbar');

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Main = require('./main/Main');

var _Main2 = _interopRequireDefault(_Main);

var _WorkspaceClipboardHandler = require('./shortcuts/WorkspaceClipboardHandler');

var _WorkspaceClipboardHandler2 = _interopRequireDefault(_WorkspaceClipboardHandler);

var _PageLoaderMain = require('../components/loaders/PageLoaderMain');

var _PageLoaderMain2 = _interopRequireDefault(_PageLoaderMain);

var _elementShortcutsDecorator = require('./shortcuts/elementShortcutsDecorator');

var _elementShortcutsDecorator2 = _interopRequireDefault(_elementShortcutsDecorator);

var _socketConstants = require('../utils/socket/socketConstants');

require('./Workspace.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var WorkspacePositioner = function WorkspacePositioner(props) {
    var isCurrentBoardFetching = props.isCurrentBoardFetching,
        isCurrentBoardFetched = props.isCurrentBoardFetched;


    if (isCurrentBoardFetching && !isCurrentBoardFetched) return _react2.default.createElement(_PageLoaderMain2.default, { color: '#cacaca' });

    return _react2.default.createElement(
        'div',
        { className: 'workspace-positioner' },
        _react2.default.createElement(_Toolbar2.default, props),
        _react2.default.createElement(_Main2.default, props),
        _react2.default.createElement(_WorkspaceClipboardHandler2.default, props)
    );
};

// Styles
// Lib


WorkspacePositioner.propTypes = {
    isCurrentBoardFetching: _propTypes2.default.bool,
    isCurrentBoardFetched: _propTypes2.default.bool
};

var Workspace = function Workspace(props) {
    var socketConnection = props.socketConnection;


    var classes = {
        disconnected: socketConnection && socketConnection.get('status') === _socketConstants.SOCKET_CONNECTION_STATUS.DISCONNECTED
    };

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('Workspace', classes) },
        _react2.default.createElement(_AppHeader2.default, props),
        _react2.default.createElement(WorkspacePositioner, props)
    );
};

Workspace.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string,
    socketConnection: _propTypes2.default.object
};

exports.default = (0, _elementShortcutsDecorator2.default)(Workspace);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/Workspace.js
// module id = 2150
// module chunks = 0